export default function videoLoader() {
    const videos = document.querySelectorAll("video[data-src]");

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
        if (entry.isIntersecting) {
            const video = entry.target;
            video.src = video.dataset.src;
            video.load();
            video.play().catch(() => {});
            observer.unobserve(video);
        }
        });
    });

    videos.forEach(video => observer.observe(video));
}